import { render } from "./ReportsControlFilesDetailsStage.vue?vue&type=template&id=87a24dee"
import script from "./ReportsControlFilesDetailsStage.vue?vue&type=script&lang=js"
export * from "./ReportsControlFilesDetailsStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__